export interface StylePreset {
  id: string
  name: string
  optimizerStyle: 'default' | 'realistic' | 'anime'
}

// Realistic is the implicit default (matches the optimizer's behavior
// when no style is specified) — `none` was a redundant duplicate, so
// we keep just the two meaningful style buckets.
export const STYLE_PRESETS: StylePreset[] = [
  { id: 'realistic', name: 'Realistic', optimizerStyle: 'realistic' },
  { id: 'anime', name: 'Anime', optimizerStyle: 'anime' },
]
